import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import { ConstanciaInasistenciaInterface } from "../../../../../interfaces/ConstanciaInasistenciaInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ConstanciaInasistenciaEditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CONSTANCIA DE INASISTENCIA";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const mutateFechaFG = useMutationData({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryConstanciaInasistencia =
    useGetData<ConstanciaInasistenciaInterface>({
      url: `/constancia_inasistencia/${evaluadosList_id}`,
      name: ["evaluado", `${evaluadosList_id}`, "constancia_inasistencia"],
    });

  const mutateConstanciaInasistencia = useMutationData({
    url: `/constancia_inasistencia/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "constancia_inasistencia"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        ...control._defaultValues,
        fecha_inasistencia: fechafg.fecha_inasistencia || "",
      });
    }
  }, [queryFechaFG.data, reset, control._defaultValues]);

  useEffect(() => {
    if (queryConstanciaInasistencia.data) {
      const constanciaI = queryConstanciaInasistencia.data;
      reset({
        ...control._defaultValues,
        fecha_programada_inasistencia:
          constanciaI.fecha_programada_inasistencia || "",
        empresanotifico_ina: constanciaI.empresanotifico_ina || "",
        evaluacion_ina: constanciaI.evaluacion_ina || "",
        integrantes_empresa_ina: constanciaI.integrantes_empresa_ina || "",
      });
    }
  }, [queryConstanciaInasistencia.data, reset, control._defaultValues]);

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative div-ignore ${isDarkMode ? "bg-gray-800 text-white" : "bg-white"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            const formData = {
              ...data,
            };

            mutateFechaFG.mutate(
              {
                data: { fecha_inasistencia: data.fecha_inasistencia },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  console.log("Fecha de Formatos Generales guardada con éxito");
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Formatos Generales:",
                    error
                  );
                },
              }
            );
            mutateConstanciaInasistencia.mutate(
              {
                data: formData,
                tipo: "put",
              },
              {
                onSuccess: () => {
                  console.log("Constancia de inasistencia guardada con éxito");
                  navigate(`/formatosG/${evaluadosList_id}`);
                  window.scrollTo(0, 0);
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Constancia de inasistencia:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario} />

          {/* Contenido del formulario */}
          <div className="p-6">
            <div className="text-left mb-8">
              <div className="flex items-center space-x-2 mb-4">
                <p className={`mt-1 translate-y-1 whitespace-nowrap ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                  Ciudad de México a
                </p>
                <Controller
                  name="fecha_inasistencia"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="fecha_inasistencia"
                      type="date"
                      value={
                        field.value || queryFechaFG.data?.fecha_inasistencia || ""
                      }
                      onChange={(e) => field.onChange(e.target.value)}
                      className={`text-left ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                    />
                  )}
                />
              </div>
              <h2 className={`text-xl font-bold mb-4 text-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                CONSTANCIA DE INASISTENCIA
              </h2>
            </div>
            <div className="flex flex-col items-start p-6 space-y-6 relative">
              <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <label htmlFor="nombre" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"} inline-block`}>
                  <strong>SE HACE CONSTAR </strong>Que el C.{" "}
                  {`${queryEvaluado.data?.nombre || ""} ${
                    queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
                </label>{" "}
                <label
                  htmlFor="nombre"
                  className={`${isDarkMode ? "text-gray-300" : "text-gray-800"} font-medium inline-block underline`}
                >
                  NO ASISTIÓ
                </label>{" "}
                a sus evaluaciones de Pruebas de Confianza, correspondiente al día{" "}
                <Controller
                  name="fecha_programada_inasistencia"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      id="fecha_programada_inasistencia"
                      type="date"
                      value={
                        field.value ||
                        queryConstanciaInasistencia.data
                          ?.fecha_programada_inasistencia ||
                        ""
                      }
                      onChange={(e) => field.onChange(e.target.value)}
                      className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                    />
                  )}
                />
                , a pesar de haber sido notificado por la empresa{" "}
                <Controller
                  name="empresanotifico_ina"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      id="empresanotifico_ina"
                      type="text"
                      value={
                        field.value ||
                        queryConstanciaInasistencia.data?.empresanotifico_ina ||
                        ""
                      }
                      onChange={(e) => field.onChange(e.target.value)}
                      className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600 placeholder-gray-500" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                    />
                  )}
                />
                , para someterse y practicarse las evaluaciones orientadas a
                cumplir los requisitos para la evaluación de{" "}
                <Controller
                  name="evaluacion_ina"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      id="evaluacion_ina"
                      type="text"
                      value={
                        field.value ||
                        queryConstanciaInasistencia.data?.evaluacion_ina ||
                        ""
                      }
                      onChange={(e) => field.onChange(e.target.value)}
                      className={`border rounded-md p-2 w-[550px] inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600 placeholder-gray-500" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                    />
                  )}
                />
                , como integrantes de la empresa{" "}
                <Controller
                  name="integrantes_empresa_ina"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      id="integrantes_empresa_ina"
                      type="text"
                      value={
                        field.value ||
                        queryConstanciaInasistencia.data
                          ?.integrantes_empresa_ina ||
                        ""
                      }
                      onChange={(e) => field.onChange(e.target.value)}
                      className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600 placeholder-gray-500" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                    />
                  )}
                />
                , lo anterior se desprende del minucioso análisis de los archivos
                que se encuentran bajo el resguardo, derivándose lo siguiente:
              </p>
              <table className={`w-full border text-left text-sm ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
                <thead>
                  <tr className={`${isDarkMode ? "bg-gray-700 text-gray-200" : "bg-gray-200 text-gray-800"}`}>
                    <th className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>Campo</th>
                    <th className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      Información
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-800"}`}>
                    <td className={`border px-4 py-2 font-medium ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      NOMBRE DE LA EMPRESA
                    </td>
                    <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      {`${queryEvaluado.data?.empresa_id?.nombre || ""}`}
                    </td>
                  </tr>
                  <tr className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-800"}`}>
                    <td className={`border px-4 py-2 font-medium ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      NOMBRE DEL EVALUADO
                    </td>
                    <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>{`${
                      queryEvaluado.data?.nombre || ""
                    } ${queryEvaluado.data?.apellido_paterno || ""} ${
                      queryEvaluado.data?.apellido_materno || ""
                    }`}</td>
                  </tr>
                  <tr className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-800"}`}>
                    <td className={`border px-4 py-2 font-medium ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      RFC
                    </td>
                    <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      {`${queryEvaluado.data?.rfc || ""}`}
                    </td>
                  </tr>
                  <tr className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-800"}`}>
                    <td className={`border px-4 py-2 font-medium ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      CARGO
                    </td>
                    <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      {`${queryEvaluado.data?.puesto || ""}`}
                    </td>
                  </tr>
                  <tr className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-800"}`}>
                    <td className={`border px-4 py-2 font-medium ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      FECHA DE PROGRAMACIÓN
                    </td>
                    <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      <Controller
                        name="fecha_programada_inasistencia"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            {...field}
                            id="fecha_programada_inasistencia"
                            type="date"
                            className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                            placeholder="Régimen"
                          />
                        )}
                      />
                    </td>
                  </tr>
                  <tr className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-800"}`}>
                    <td className={`border px-4 py-2 font-medium ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      EVALUACIONES PROGRAMADAS
                    </td>
                    <td className={`border px-4 py-2 ${isDarkMode ? "border-gray-600" : "border-gray-400"}`}>
                      <Controller
                        name="evaluacion_ina"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <textarea
                            {...field}
                            id="evaluacion_ina"
                            className={`border rounded-md p-2 w-[500px] inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600 placeholder-gray-500" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                            placeholder="Evaluaciones"
                            rows={5}
                          />
                        )}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`bg-red-500 hover:bg-red-600 text-white ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              >
                Regresar
              </Button>
              <button
                type="submit"
                className={`rounded px-4 py-2 z-10 transition-colors ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};
